import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./HF.css";
import layam from "../assets/logow.jpg";
import { LuLogOut } from "react-icons/lu";

const Header = ({ isLoggedIn, setIsLoggedIn }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("userdetails");
    sessionStorage.setItem("manualLogout", "true");
    setIsLoggedIn(false);
    navigate("/");
  };

  useEffect(() => {
    if (location.pathname === "/") {
      localStorage.removeItem("userdetails");
      setIsLoggedIn(false);
    } else {
      const userDetails = JSON.parse(localStorage.getItem("userdetails"));
      if (userDetails?.username) {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    }
  }, [location.pathname]);

  return (
    <header className="header">
      <div className="container">
        <img className="logo" src={layam} alt="logo" />
        {/* <h1 ">My Website</h1> */}
        <nav>
          <ul className="nav-list">
            <li>
              {isLoggedIn ? (
                <button onClick={handleLogout} className="btton">
                  Logout{" "}
                  <div>
                    <LuLogOut />
                  </div>
                </button>
              ) : null}
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
